// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"520bef0f","787":"09ed82aa","921":"37ac7b84"}[chunkId] + ".chunk.js";
};